<template>
  <div>
    <yxt-select
      v-if="!multiple"
      ref="dropTree"
      v-model="department.id"
      class="talentrv-select-tree__wrapper"
      :placeholder="$t('pc_gwnl_global_lbl_dept').d('部门')"
      popper-class="tree-wrap"
      multiple
      collapse-tags
      clearable
      :disabled="disabled"
      style="width: 180px;"
      size="small"
      @clear="clear"
    >
      <yxt-option
        class="talentrv-drop__tree"
        :value="department.id"
        :label="department.name"
      >
        <div style="width: 400px;">
          <yxtbiz-dept-tree
            ref="deptTree"
            class="yxtbiz-dept-virtual-tree"
            :default-expanded-keys="[]"
            :functions="functions"
            :filterable="filterable"
            @nodeClick="nodeClick"
            :functionCode="functionCode"
            :dataPermissionCode="dataPermissionCode"
            :enableGroupCorp="enableGroupCorp"
            :visibleOrgSelector="visibleOrgSelector"
          />
        </div>
      </yxt-option>
      <template
        slot="tag"
      >
        <yxtbiz-dept-name
          :name="department.name"
        />
      </template>
    </yxt-select>
    <yxt-select
      v-else
      v-model="multiDepartment"
      multiple
      :placeholder="$t('pc_gwnl_global_lbl_dept').d('部门')"
      style="width: 180px;"
      size="small"
      icon-name="more"
      hidden-option
      collapse-tags
      value-key="id"
      prop-label="name"
      :disabled="disabled"
      @visible-change="onMultiSelectorClick"
      @remove-tag="onMultiRemoveDept"
    >
      <template
        slot="tag"
        slot-scope="{ data }"
      >
        <yxtbiz-dept-name
          :name="data.currentLabel"
        />
      </template>
    </yxt-select>
    <yxtbiz-eval-select-department
      :visible.sync="showMultiDrawer"
      :default-value="multiDepartment"
      :check-strictly="true"
      :children-included="childrenIncluded"
      :function-code="functionCode"
      :dataPermissionCode="dataPermissionCode"
      @on-selection="onMultiDeptSelected"
    ></yxtbiz-eval-select-department>
  </div>
</template>

<script>
import evalSelectDepartment from './components/eval-select-department';

export default {
  name: 'YxtbizEvalSelectDepartmenttree',
  components: {
    yxtbizEvalSelectDepartment: evalSelectDepartment
  },
  props: {
    functions: {
      type: Boolean,
      default: false
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    functionCode: {
      type: String,
      default: ''
    },
    dataPermissionCode: {
      type: String,
      default: ''
    },
    enableGroupCorp: {
      type: Boolean,
      default: false
    },
    visibleOrgSelector: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    childrenIncluded: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      options: {
        errorCallback: function() { },
        updateCallback: function() { },
        headers: {
          token: localStorage.getItem('token'),
          Source: 501
        },
        mutidepart: false, // 是否多选,
        showUserCount: true, // 是否显示部门人数,
        theme: 'frame-department-tree-style1', // 使用皮肤
        searchenable: false,
        data: {
          hasPermission: 1,
          ouRoutingNumbers: [],
          isQueryAllDept: 1 // 1-超级管理员  0-部门管理员
          // 'isOuRoutingNumber': 0,
          // 'removeNumber': '0057',
        }
      },
      selectedDepts: {},
      department: {
        name: '',
        id: ''
      },
      multiDepartment: [], // 多选选中部门
      showMultiDrawer: false // 多选弹层状态
    };
  },
  watch: {
    selectedDepts(curVal, oldVal) {
      this.selectedDepts = curVal === '' || curVal === null ? [] : curVal;
      for (let key in this.selectedDepts) {
        // key 部门id
        this.department.name = this.selectedDepts[key].ouName;
        this.department.id = key;
      }
      this.$emit('change', this.department);
    }
  },
  methods: {
    nodeClick(data, node) {
      this.department.id = [data.id];
      this.department.name = data.name;
      if (!this.$isV1) {
        this.$refs.dropTree.blur();
      }
      this.$emit('change', data);
    },
    clear() {
      this.department = {
        name: '',
        id: ''
      };
      this.$emit('change', this.department);
    },
    onMultiSelectorClick(visible) {
      visible && (this.showMultiDrawer = !this.showMultiDrawer);
    },
    onMultiDeptSelected(e) {
      this.multiDepartment = e;
      this.$emit('change', e);
    },
    onMultiRemoveDept() {
      this.$emit('change', this.multiDepartment);
    }
  }
};
</script>
<style lang="scss" scoped>
.talentrv-select-tree__wrapper {
  ::v-deep .yxt-tag__close {
    display: none;
  }
  ::v-deep .yxt-tag.yxt-tag--info {
    background: none;
    border: none;
    font-size: 14px;
  }
}

.talentrv-drop__tree {
  min-width: 400px;
  height: 480px;
  padding: 0 !important;
  background: #fff !important;
  overflow: scroll !important;

  ::v-deep .yxt-tree-node__content {
    height: auto;
  }

  ::v-deep .tree-scroll-wrap {
    .yxt-scrollbar {
      min-width: 400px;
      height: 480px;
    }
  }
}
</style>
<style lang="scss">
.tree-wrap {
  .yxt-scrollbar__wrap {
    max-height: 100% !important;
  }
}
</style>
